/**
 * Costos y plazos de despacho (ENV-01, ENV-03).
 *
 * Los montos ya no estan escritos aca: salen de las tarifas que administra el
 * backoffice (ADM-10), las mismas que se cobran en el checkout. Antes eran tres
 * numeros a mano en este archivo, y cada cambio de tarifa los dejaba mintiendo.
 *
 * Siguen siendo un supuesto —la tabla real por region es la pregunta 3 abierta
 * del cliente— pero ahora es un supuesto que se corrige desde el panel y no
 * desde el codigo.
 *
 * Se listan SOLO las entregas que el panel deja encendidas: sin despacho no
 * aparecen las regiones ni el despacho gratis, sin retiro no aparece la sala de
 * ventas, y sin ninguna de las dos queda una sola fila que dice que se coordina.
 */
import { SITIO } from '../../configuracion/sitio';
import { useDespacho } from '../../contexto/despacho-contexto';
import { ofreceDespacho, ofreceRetiro, soloCoordinar } from '../../utilidades/entrega';
import { pesos } from '../../utilidades/formato';

interface Opcion {
  titulo: string;
  detalle: string;
  costo: string;
  gratis?: boolean;
}

/** La Metropolitana se muestra aparte: es de donde viene la mayoria. */
const CODIGO_METROPOLITANA = 'RM';

export function BloqueDespacho() {
  const { opciones } = useDespacho();

  const metropolitana = opciones?.regiones.find(
    (region) => region.codigo === CODIGO_METROPOLITANA,
  );

  // "Desde" real: la region mas barata de las que no son la Metropolitana.
  const otras = (opciones?.regiones ?? []).filter(
    (region) => region.codigo !== CODIGO_METROPOLITANA,
  );
  const masBarata = otras.length > 0 ? Math.min(...otras.map((region) => region.costo)) : null;

  const conDespacho = ofreceDespacho(opciones);

  const filas: Opcion[] = [
    ...(ofreceRetiro(opciones)
      ? [
          {
            titulo: 'Retiro en tienda',
            detalle: `${SITIO.direccion.calle}, ${SITIO.direccion.comuna}`,
            costo: 'Gratis',
            gratis: true,
          },
        ]
      : []),
    ...(conDespacho && metropolitana !== undefined
      ? [
          {
            titulo: 'Region Metropolitana',
            detalle: metropolitana.plazo,
            costo: pesos(metropolitana.costo),
          },
        ]
      : []),
    ...(conDespacho && masBarata !== null
      ? [
          {
            titulo: 'Regiones',
            detalle: 'Segun destino',
            costo: `desde ${pesos(masBarata)}`,
          },
        ]
      : []),
    ...(conDespacho && opciones !== null
      ? [
          {
            titulo: 'Despacho gratis',
            detalle: `En compras sobre ${pesos(opciones.despachoGratisDesde)}`,
            costo: 'A todo Chile',
            gratis: true,
          },
        ]
      : []),
    ...(soloCoordinar(opciones)
      ? [
          {
            titulo: 'Entrega por coordinar',
            detalle: `La acordamos contigo por teléfono al ${SITIO.whatsappVisible}`,
            costo: 'A convenir',
          },
        ]
      : []),
  ];

  return (
    <ul>
      {filas.map((opcion) => (
        <li className="despacho-fila" key={opcion.titulo}>
          <span>
            <strong>{opcion.titulo}</strong>
            <span className="d">{opcion.detalle}</span>
          </span>
          <strong className={opcion.gratis === true ? 'costo-gratis' : undefined}>
            {opcion.costo}
          </strong>
        </li>
      ))}
    </ul>
  );
}
